import { LOCALE, NOT_AVAILABLE } from '../config.js';
import get from 'lodash/get'
import isNull from 'lodash/isNull'

export const getSign = function (value, showPositive = false) {
	if (value < 0) {
		return '–'
	} else if (value > 0 && showPositive) {
		return '+'
	} else {
		return ''
	}
}

import { format } from 'd3-format';
const f = format('.1f');

export const formatNumber = function (value) {
	let n
	if (value === 0) {
		n = value
	} else if (Number(value) === value && value % 1 === 0) {
		n = value
	} else {
		n = f(value)
	}

	return (Math.abs(n) !== 0 ? getSign(value) : '') + Math.abs(n)
}

export const between = function (v, l, h) {
	// value, low, high
	return Math.max(Math.min(v, h), l)
}

function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

export const getLongDate = function (d, s = true) {
	if (!isValidDate(d)) return NOT_AVAILABLE
	const date = new Date(d)
  const m = date.getMonth()
  const month = get(LOCALE, [s ? 'months' : 'months_short', m], m + 1)
  return `${month} ${date.getFullYear()}`
}

export const gs = function (obj, key) {
	const s = get(obj, key, NOT_AVAILABLE)
	return isNull(s) ? NOT_AVAILABLE : s
}